import { companyInfo } from '@/mocks/company';
import { products } from '@/mocks/products';

export default function TechTableSection() {
  const cunhaQuente = products.filter((p) => p.category === 'Cunha Quente');
  const extrusoras = products.filter((p) => p.category === 'Extrusora');

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-2 block">Especificações</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight">Comparativo Técnico</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg">Compare as especificações técnicas das máquinas de cunha quente e escolha o modelo ideal para seu projeto.</p>
        </div>

        <div className="mb-8">
          <h3 className="text-sm font-bold text-foreground-900 uppercase tracking-wide mb-3 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-primary-500 inline-block" />
            Máquinas de Cunha Quente
          </h3>
          <div className="overflow-x-auto rounded-xl border border-background-200/70 bg-white">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-foreground-900 text-white">
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Modelo</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Potência</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Espessura</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Velocidade</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Temperatura</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PEAD</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PVC</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">LLDPE</th>
                </tr>
              </thead>
              <tbody>
                {cunhaQuente.map((product, index) => (
                  <tr key={product.id} className={`border-t border-background-200/50 ${index % 2 === 0 ? 'bg-white' : 'bg-background-50/60'}`}>
                    <td className="px-4 py-3 font-bold text-foreground-950 whitespace-nowrap">
                      {product.name}
                      {product.badge && <span className="ml-2 text-[10px] bg-primary-500 text-white px-1.5 py-0.5 rounded font-bold uppercase">{product.badge}</span>}
                    </td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.potencia}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.material}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.velocidade}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.temperatura}</td>
                    <td className="px-4 py-3 text-center">
                      {product.compatibilidade.pead ? <i className="ri-check-line text-primary-600" /> : <i className="ri-close-line text-foreground-300" />}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {product.compatibilidade.pvc ? <i className="ri-check-line text-primary-600" /> : <i className="ri-close-line text-foreground-300" />}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {product.compatibilidade.lldpe ? <i className="ri-check-line text-primary-600" /> : <i className="ri-close-line text-foreground-300" />}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-sm font-bold text-foreground-900 uppercase tracking-wide mb-3 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 inline-block" />
            Extrusoras Manuais
          </h3>
          <div className="overflow-x-auto rounded-xl border border-background-200/70 bg-white">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-foreground-900 text-white">
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Modelo</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Potência</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Produção</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Temperatura Máx.</th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">Diâm. Fio</th>
                  <th className="text-center px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">PEAD</th>
                </tr>
              </thead>
              <tbody>
                {extrusoras.map((product, index) => (
                  <tr key={product.id} className={`border-t border-background-200/50 ${index % 2 === 0 ? 'bg-white' : 'bg-background-50/60'}`}>
                    <td className="px-4 py-3 font-bold text-foreground-950 whitespace-nowrap">{product.name}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.potencia}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.velocidade}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.temperatura}</td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{product.specs.material}</td>
                    <td className="px-4 py-3 text-center">
                      {product.compatibilidade.pead ? <i className="ri-check-line text-primary-600" /> : <i className="ri-close-line text-foreground-300" />}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 bg-white rounded-2xl border border-background-200/70 px-6 py-6">
          <div>
            <p className="text-foreground-900 font-bold text-sm uppercase tracking-wide mb-1">Precisa de orientação técnica?</p>
            <p className="text-foreground-500 text-xs leading-relaxed max-w-lg">Nossa equipe técnica analisa o seu projeto — espessura da geomembrana, área de soldagem, tipo de material e condições de campo — e indica o modelo mais adequado.</p>
          </div>
          <a
            href={`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.')}`}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide flex-shrink-0"
          >
            <i className="ri-whatsapp-line" />
            Consultar Especialista
          </a>
        </div>
      </div>
    </section>
  );
}